import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.241-.446.684-.637 1.435-.335 1.918.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 4.5H6V3h15a3 3 0 013 3v9h-1.5V6A1.5 1.5 0 0021 4.5zm-16.5 3A1.5 1.5 0 003 9v7.5A1.5 1.5 0 004.5 18H18a1.5 1.5 0 001.5-1.5V9A1.5 1.5 0 0018 7.5H4.5zM1.5 9a3 3 0 013-3H18a3 3 0 013 3v7.5a3 3 0 01-3 3H4.5a3 3 0 01-3-3V9z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.241-.446.684-.637 1.435-.335 1.918.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 4.5H6V3h15a3 3 0 013 3v9h-1.5V6A1.5 1.5 0 0021 4.5zm-16.5 3A1.5 1.5 0 003 9v7.5A1.5 1.5 0 004.5 18H18a1.5 1.5 0 001.5-1.5V9A1.5 1.5 0 0018 7.5H4.5zM1.5 9a3 3 0 013-3H18a3 3 0 013 3v7.5a3 3 0 01-3 3H4.5a3 3 0 01-3-3V9z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 26.586c-1.494-1.096-.354-3.292.05-3.946-.728.804-1.456 1.606-2.022 2.482-.892 1.368-1.274 2.87-.67 3.836 1.082 1.736 3.68.932 5.336.234L33 22.708l-15.188 4.01c-1.272.332-2.294.288-2.876-.132z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 9H12V6h30c3.312 0 6 2.688 6 6v18h-3V12c0-1.656-1.344-3-3-3zM9 15c-1.656 0-3 1.344-3 3v15c0 1.656 1.344 3 3 3h27c1.656 0 3-1.344 3-3V18c0-1.656-1.344-3-3-3H9zm-6 3c0-3.312 2.688-6 6-6h27c3.312 0 6 2.688 6 6v15c0 3.312-2.688 6-6 6H9c-3.312 0-6-2.688-6-6V18z",
    clipRule: "evenodd"
  }))
};
export var Cards = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});